import { Box, Drawer, Tab, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import { TabList, TabContext, TabPanel } from '@mui/lab';
import { useBuildingItem } from './hooks';
import { History } from 'components/History/';
import { General } from './General';
import Beds from './Beds';

interface IBuildingItemProps {
  open: boolean;
  handleClose: () => void;
  itemId: string;
}

export const BuildingItem = ({
  open,
  handleClose,
  itemId,
}: IBuildingItemProps) => {
  const {
    handleTriggerChangeTab,
    tabIndex,
    building,
    buildingHistory,
    historyPage,
    setHistoryPage,
    handleCloseTrigger,
    historyTabIndex,
  } = useBuildingItem({
    id: itemId,
    handleClose,
  });

  return (
    <Drawer
      ModalProps={{ onClose: handleCloseTrigger }}
      anchor='right'
      open={open}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '600px',
          height: '100%',
          paddingX: 3,
          paddingY: 3,
          overflowY: 'auto',
          scrollbarWidth: 'thin',
        }}
      >
        {building?.data && (
          <>
            <Box
              sx={{
                display: 'flex',
                position: 'relative',
                justifyContent: 'space-between',
                width: '100%',
                padding: '0',
                pb: '1rem',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <MapsHomeWorkIcon
                  sx={{ width: '36px', height: '36px' }}
                  color='primary'
                />

                <Box
                  sx={{ display: 'flex', flexDirection: 'column', pl: '1rem' }}
                >
                  <Typography variant='body1'>{building.data.name}</Typography>
                  <Typography
                    variant='body2'
                    sx={{ color: theme => theme.palette.semiBlack.main }}
                  >
                    Building
                  </Typography>
                </Box>
              </Box>

              <Box
                onClick={handleCloseTrigger}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  ':hover': {
                    cursor: 'pointer',
                    bgcolor: theme => theme.palette.grey[50],
                    borderRadius: '6px',
                  },
                  height: '30px',
                  width: '30px',
                }}
              >
                <ClearIcon />
              </Box>
            </Box>
            <TabContext value={tabIndex}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <TabList onChange={handleTriggerChangeTab}>
                  <Tab label='GENERAL' value='1' />
                  <Tab label='BEDS' value='2' />
                  <Tab label='HISTORY' value={historyTabIndex} />
                </TabList>
              </Box>
              <TabPanel
                sx={{
                  padding: '0 !important',
                }}
                value='1'
              >
                <Box
                  sx={{
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                    pt: 1,
                  }}
                >
                  <General building={building.data} />
                </Box>
              </TabPanel>
              <TabPanel
                sx={{
                  padding: '0 !important',
                }}
                value='2'
              >
                <Box
                  sx={{
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                    pt: 1,
                  }}
                >
                  <Beds building={building?.data} />
                </Box>
              </TabPanel>
              <TabPanel
                sx={{
                  padding: '0 !important',
                }}
                value={historyTabIndex}
              >
                <Box
                  sx={{
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                  }}
                >
                  {buildingHistory && (
                    <History
                      page={historyPage}
                      changePage={setHistoryPage}
                      history={buildingHistory.history}
                      count={buildingHistory.count}
                    />
                  )}
                </Box>
              </TabPanel>
            </TabContext>
          </>
        )}
      </Box>
    </Drawer>
  );
};
